import {MITTWALD_API, Schemas} from '../middleware/MittwaldApi'
import * as ActionTypes from '../constants/ActionTypes'
import {initialize as initializeForms, touch as touchFormField} from 'redux-form'

import {getAlternateSepaForm, getSepaForm} from '../selectors/Forms'

import {queryBearerToken} from './UserAuthentication'

// **************************************************************************************************************
export const toggleAlternateSepaInput = () => (dispatch, getState) => {

    // copy name value from sepa -> alternate
    if (getSepaForm(getState()) && getSepaForm(getState()).values && getSepaForm(getState()).values.accountHolder
        && !(getAlternateSepaForm(getState()) && getAlternateSepaForm(getState()).values && getAlternateSepaForm(getState()).values.accountHolder)) {
        dispatch(initializeForms('alternateSepaPayment',
            {
                accountHolder: getSepaForm(getState()).values.accountHolder
            }
        ))
        dispatch(touchFormField('alternateSepaPayment', 'accountHolder'))
    }

    // copy name value from alternate -> sepa
    if (!(getSepaForm(getState()) && getSepaForm(getState()).values && getSepaForm(getState()).values.accountHolder)
        && (getAlternateSepaForm(getState()) && getAlternateSepaForm(getState()).values && getAlternateSepaForm(getState()).values.accountHolder)) {
        dispatch(initializeForms('sepaPayment',
            {
                accountHolder: getAlternateSepaForm(getState()).values.accountHolder
            }
        ))
        dispatch(touchFormField('sepaPayment', 'accountHolder'))
    }

    dispatch({
        type: ActionTypes.ALTERNATE_SEPA_TOGGLE
    })

}

const fetchBankAccountVerification = (bearer, accountNumber, bankAddress) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.BANKACCOUNT_VERIFY_REQUEST, ActionTypes.BANKACCOUNT_VERIFY_SUCCESS, ActionTypes.BANKACCOUNT_VERIFY_FAILURE],
        endpoint: `bankdata/actions/convert`,
        bearer: bearer,
        schema: Schemas.BANKACCOUNT,
        method: 'POST',
        postData: {
            bankAccountNumber: accountNumber,
            bankCode: bankAddress
        }
    }
})

export const queryBankAccountVerification = (accountNumber, bankAddress) => (dispatch, getState) => {
    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchBankAccountVerification(getState().token.bearer, accountNumber, bankAddress))
    })
}

export const setVerifiedBankAccount = (accountHolder, iban, bic) => (dispatch, getState) => {
    dispatch(initializeForms('sepaPayment',
        {
            accountHolder: accountHolder,
            iban: iban,
            bic: bic
        }
    ))
    dispatch(touchFormField('sepaPayment', 'accountHolder', 'iban', 'bic'))
}



/** WEBPACK FOOTER **
 ** ./src/actions/AlternateSepaInput.js
 **/